<template>
  <div>
    <div class="select-wrap">
      <div>
        <el-date-picker
          v-model="time"
          @change="onChangeTime"
          :clearable="false"
          unlink-panels
          type="daterange"
          format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small">
        </el-date-picker>
      </div>
      <div class="checkbox">
        <el-select v-model="checkedValue" size="small" clearable placeholder="请选择" @change="onChangeCheck">
          <el-option
            label="充值"
            :value="1">
          </el-option>
          <el-option
            label="扣款"
            :value="2">
          </el-option>
          <el-option
            label="编辑额度"
            :value="3">
          </el-option>
        </el-select>
      </div>
      <div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button type="primary" @click="exportDetail" size="small">导出明细</el-button>
      </div>
    </div>
    <div class="jzbWrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="depositStatus" label="类型">
          <template slot-scope="scope">
            {{scope.row.operationType | filterOperationType}}
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="扣款/充值原因">
        </el-table-column>
        <el-table-column prop="createdOn" label="扣款/充值时间">
          <template slot-scope="scope">
            <span v-if="scope.row.createdOn">{{moment(scope.row.createdOn).format('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="金额">
          <template slot-scope="scope">
            <span :class="valueClass(scope.row.value)">{{scope.row.value}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import {
  jzbQeryPayShopDepositLog,
  jzbExportPayShopDepositLog
} from '@/models/jzbModel'
import { type } from 'os'
const plainOptions = [
  {
    label: '订单入账',
    value: 3
  },
  {
    label: '订单撤销',
    value: 4
  },
  {
    label: '提现',
    value: 5
  }
]
export default {
  props: ['type'],
  data () {
    return {
      loading: false,
      expandLoading: false,
      plainOptions: plainOptions,
      checkedValue: '',
      tableData: [],
      time: [moment().subtract(3, 'months').valueOf(), moment().valueOf()],
      currentPage: 1,
      totalCount: 0,
      pagesize: 20
    }
  },
  filters: {
    filterOperationType (val) {
      let str = ''
      switch (val) {
        case 1:
          str = '充值'
          break
        case 2:
          str = '扣款'
          break
        case 3:
          str = '编辑额度'
          break
        default:
          break
      }
      return str
    }
  },
  methods: {
    moment,
    onChangeTime (value) {
      this.time = value
      // let time = []
      // time[0] = Object.assign({}, moment(value[0]))
      // time[1] = Object.assign({}, moment(value[1]))
      // let startTime = moment(time[0])
      // let endtTime = moment(time[1]).subtract(1, 'days')
      // if (!endtTime.subtract(3, 'months').isBefore(startTime)) {
      //   this.$message.error('选择的时间跨度最大为3个月')
      //   this.time = [moment().subtract(3, 'months').valueOf(), moment().valueOf()]
      // } else {
      //   // this.time[0] = value[0].valueOf()
      //   // this.time[1] = value[1].valueOf()
      //   this.time = value
      // }
    },
    onChangeCheck () {
      // this.initData()
    },
    getData () {
      this.initData()
    },
    initData () {
      this.loading = true
      jzbQeryPayShopDepositLog({
        'shopId': parseInt(localStorage.getItem('shop_id')),
        operationType: this.checkedValue,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize
      }).then(res => {
        if (res.code === 200) {
          let list = res.data.content
          this.tableData = list
          this.totalCount = parseInt(res.data.totalElements)
          this.loading = false
        }
      })
    },
    exportDetail () {
      let params = {
        shopId: Number(localStorage.getItem('shop_id')),
        operationType: this.checkedValue,
        startDate: moment(this.time[0]).format('YYYY-MM-DD'),
        endDate: moment(this.time[1]).format('YYYY-MM-DD')
      }
      window.open(jzbExportPayShopDepositLog(params))
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.initData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.initData()
    },
    valueClass (val) {
      if (typeof val === 'number') {
        if (val < 0) {
          return 'red'
        } else {
          return 'blue'
        }
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style scoped>
    .select-wrap {
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .select-wrap > div {
        padding-right: 20px;
    }

    .checkbox {
        margin-right: auto;
        margin-left: 15px;
    }
    .red{
      color: #ff4545;
    }
    .blue{
      color: #3dca21;
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/pay-shop-deposit-log.vue